import { Tab, TabItem, TabList, Tabs } from '@economist/design-system/dist/umd/common';
import * as React from 'react';
export default {
  Tab,
  TabItem,
  TabList,
  Tabs,
  React
};